module.exports = __webpack_public_path__ + "static/media/googleplay.f9e4ee26.png";